<template>
  <div class="tab-content">
    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- estimate -->
      <el-tab-pane v-if="selectedRow.type === 'project'" label="Estimate" name="estimateProject">
        <estimateTab
          v-model="activeEstimateTab"
          :isProject="isProject"
          :selectedRow="selectedRow"/>
      </el-tab-pane>

      <el-tab-pane v-else label="Estimate" name="estimateTask">
        <estimateTab
          v-model="activeEstimateTab"
          :isProject="isProject"
          :selectedRow="selectedRow"/>
      </el-tab-pane>

      <!-- purchase -->
      <el-tab-pane v-if="selectedRow.type === 'project'" label="Purchase" name="purchaseProject">
        <purchaseProjectTable :selectedRow="selectedRow" ref="purchaseProjectTable"/>
      </el-tab-pane>

      <el-tab-pane v-else label="Purchase" name="purchaseTask">
        <purchaseTaskTable :selectedRow="selectedRow" ref="purchaseTaskTable"/>
      </el-tab-pane>

    </el-tabs>

    <!-- bookmark -->
    <div class="book-mark-block pointer" v-if="bookmarkList">
      <div v-if="selectedRow.type === 'project'">
        <div v-if="bookmarkListProject.accountTHINK" @click="changeBookMarkProject(bookmarkListProject.accountTHINK, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>
        <div v-else @click="changeBookMarkProject(bookmarkListProject.accountTHINK, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>
      </div>

      <div v-else>
        <div v-if="bookmarkList.accountTHINK" @click="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>
        <div v-else @click="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>
      </div>

      <!-- <el-checkbox v-if="selectedRow.type === 'project'" size="mini" @change="changeBookMarkProject(bookmarkListProject.accountTHINK, $route.query.companyId, selectedRow.projectId)" v-model="bookmarkListProject.accountTHINK" border><i :class="[bookmarkListProject.accountTHINK ? activeStar : notActiveStar ]"></i></el-checkbox>
      <el-checkbox v-else size="mini" @change="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.projectId, selectedRow.id)" v-model="bookmarkList.accountTHINK" border><i :class="[bookmarkList.accountTHINK ? activeStar : notActiveStar ]"></i></el-checkbox> -->
    </div>

  </div>
</template>

<script>
  import purchaseTaskTable from '@/components/Projects/accountTHINK/purchase/purchaseTaskTable.vue'
  import purchaseProjectTable from '@/components/Projects/accountTHINK/purchase/purchaseProjectTable.vue'
  import axios from 'axios'
  import moment from 'moment'

  // estimate
  import estimateTab from '@/components/Projects/accountTHINK/estimate/estimateTab.vue'

  // purchase
  // TODO:

  export default {
    components: {
      purchaseTaskTable,
      purchaseProjectTable,
      estimateTab
    },
    props: [
      'isProject',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListProject',
    ],
    data() {
      return {
        activeEstimateTab: '',
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId) {
        // estimate
        if(tab.label === "Estimate" && tab.name == "estimateProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Estimate" && tab.name == "estimateTask" && !this.isProject){
          // dispatch
        }

        // purchase
        if(tab.label === "Purchase" && tab.name == "purchaseProject" && this.isProject){
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
          loader.hide()
          // this.$refs.purchaseProjectTable.handleClick(tab, event, projectTaskId)
        }
        if(tab.label === "Purchase" && tab.name == "purchaseTask" && !this.isProject){
          // dispatch
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
          loader.hide()
          // this.$refs.purchaseTaskTable.handleClick(tab, event, projectTaskId)
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changeBookMark(state, companyid, projectId, taskId){
        let data = this.bookmarkList
        data.accountTHINK = !this.bookmarkList.accountTHINK
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
          .then(response => {
            if (this.bookmarkList.accountTHINK) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
      changeBookMarkProject(state, companyId, projectId, taskId){
        let data = this.bookmarkListProject
        data.accountTHINK = !this.bookmarkListProject.accountTHINK
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProject?companyId=${companyId}&projectId=${projectId}`, data)
          .then(response => {
            if (this.bookmarkListProject.accountTHINK) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
// [ Modal ] end
.tab-content{
  position:relative;
  .book-mark-block{
    position:absolute;
    top:0;
    right:0;
    .el-checkbox__input{
      display:none;
    }
    .el-checkbox {
      border: none;
    }
    .el-checkbox__label{
      font-size:20px !important;
      color: #409EFF;
    }
  }
}
</style>
